import { GQL_ID, NestedFilter } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'



export type SyncProductsToGroupInput = {
  byFilter?: boolean
  filter?: NestedFilter
  product_group_id: GQL_ID
  product_ids?: GQL_ID[]
  xids?: string[]
  operation: 'attach' | 'detach' | 'sync'
}



export const GQL_MUTATION_SYNC_PRODUCTS_TO_GROUPS = gql`
  mutation syncProductsToGroup (
    $byFilter: Boolean
    $filter: NestedFilterInput
    $product_group_id: ID!
    $product_ids: [ID]
    $xids: [String]
    $operation: String
  ){
  syncProductsToGroup(
    byFilter: $byFilter
    filter: $filter
    product_group_id: $product_group_id
    product_ids: $product_ids
    xids: $xids
    operation: $operation
  )
}
`

export const useMutateSyncProductsToGroup = () => useMutation<boolean, SyncProductsToGroupInput>(GQL_MUTATION_SYNC_PRODUCTS_TO_GROUPS)